import React from 'react';
import { PropTypes } from 'prop-types';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import './Paginations.css';
import { ItensPerPageDropdown } from './components/ItensPerPageDropdown';
import { SelectPageDropdown } from './components/SelectPageDropdown';

export function GovBrPagination({
  pages,
  currentPage,
  setCurrentPage,
  setItensPerPage,
  items,
  totalItens,
}) {
  function previusPage(pageNumber) {
    if (pageNumber > 0) setCurrentPage(pageNumber - 1);
  }

  function nextPage(totalPages, page) {
    if (page < totalPages - 1) setCurrentPage(page + 1);
  }

  return (
    <div>
      <nav
        className="br-pagination"
        aria-label="Paginação de resultados"
        data-total="50"
        data-current="1"
        data-per-page="20"
      >
        <div className="pagination-per-page">
          <div className="br-select first">
            <div className="br-input">
              <p>Exibir</p>
              <ItensPerPageDropdown
                totalItens={totalItens}
                setItensPerPage={setItensPerPage}
                setCurrentPage={setCurrentPage}
              />
            </div>
          </div>
        </div>
        <span className="br-divider d-none d-sm-block mx-3" />
        <div className="pagination-information d-none d-sm-flex">
          <span className="current">{items * currentPage + 1}</span>
          &ndash;
          {items * (currentPage + 1) > totalItens ? (
            <span className="per-page">{totalItens}</span>
          ) : (
            <span className="per-page">{items * (currentPage + 1)}</span>
          )}
          &nbsp;de&nbsp;
          <span className="total">{totalItens}</span>
          &nbsp;itens
        </div>
        <div className="pagination-go-to-page d-none d-sm-flex ml-auto">
          <div className="br-select">
            <div className="br-input">
              <p>Página</p>
              <SelectPageDropdown
                pages={pages}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </div>
          </div>
        </div>
        <span className="br-divider d-none d-sm-block mx-3" />
        <div className="pagination-arrows ml-auto ml-sm-0">
          <button
            onClick={() => previusPage(currentPage)}
            className="br-button circle"
            type="button"
            aria-label="Voltar página"
          >
            <FaAngleLeft />
          </button>
          <button
            onClick={() => nextPage(pages, currentPage)}
            className="br-button circle"
            type="button"
            aria-label="Avançar página"
          >
            <FaAngleRight />
          </button>
        </div>
      </nav>
    </div>
  );
}

GovBrPagination.propTypes = {
  pages: PropTypes.element.isRequired,
  setCurrentPage: PropTypes.element.isRequired,
  setItensPerPage: PropTypes.element.isRequired,
  totalItens: PropTypes.number,
  items: PropTypes.number,
  currentPage: PropTypes.number,
};
GovBrPagination.defaultProps = {
  totalItens: 0,
  items: 5,
  currentPage: 1,
};
